import Layout from '@/layout';

const xgjyActivityManageRouter = {
  path: '/editor',
  component: Layout,
  redirect: '/editor/position',
  name: 'editorManage',
  meta: {
    title: '内容管理',
    icon: 'el-icon-edit-outline',
    roles: ['introManage'],
  },
  children: [
    {
      path: 'article',
      component: () => import('@/views/editor/article/index'),
      name: 'article',
      meta: { title: '文章管理', icon: 'el-icon-document', roles: ['sysPosition'] },
    },
    {
      path: 'category',
      component: () => import('@/views/editor/category/index'),
      name: 'category',
      meta: { title: '分类管理', icon: 'el-icon-document', roles: ['sysPosition'] },
    },
    {
      path: 'banner',
      component: () => import('@/views/editor/banner-manage/index'),
      name: 'banner',
      meta: { title: 'banner管理', icon: 'el-icon-document', roles: ['sysPosition'] },
    },
    {
      path: 'position',
      component: () => import('@/views/editor/position/index'),
      name: 'position',
      meta: { title: 'banner位置管理', icon: 'el-icon-document', roles: ['sysPosition'] },
    },


    // {
    //   path: 'contact',
    //   component: () => import('@/views/editor/contact/index'),
    //   name: 'contactEditor',
    //   meta: { title: '联系我们', icon: 'el-icon-document', roles: ['contact'] },
    // },
    // {
    //   path: 'eleme',
    //   component: () => import('@/views/editor/eleme/index'),
    //   name: 'elemeEditor',
    //   meta: { title: '饿了么领取操作', icon: 'el-icon-document', roles: ['eleme'] },
    // },
    // {
    //   path: 'power',
    //   component: () => import('@/views/equiry/power/index'),
    //   name: 'material',
    //   meta: { title: '权利义务', icon: 'el-icon-document', roles: ['power'] },
    // },
  ],
};
export default xgjyActivityManageRouter;
